import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueElementLoading from "vue-element-loading";
import VeeValidate from "vee-validate";
import VueSweetalert2 from "vue-sweetalert2";
import Notifications from "vue-notification";
import vSelect from "vue-select";
import { Datetime } from "vue-datetime";
import error from "./components/validation-error.vue";
// import pagination from './components/pagination.vue';
import Multiselect from "vue-multiselect";
import VueChatScroll from "vue-chat-scroll";
// import VCalendar from 'v-calendar';
// import StarRating from 'vue-star-rating';
import Vuetify from "vuetify";
import MoneyFormat from "vue-money-format";
import VueCryptojs from "vue-cryptojs";
import VueProgressBar from "vue-progressbar";

import { GlobalMixins } from "./shared/mixins";
import DataTable from "./components/DataTable.vue";
import CustomModal from "./components/CustomModal.vue";
import PfizerTable from "./components/PfizerTable.vue";
import TableTools from "./components/TableTools.vue";
import CustomButton from "./components/CustomButton.vue";
// import store from './store';
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import lang from "element-ui/lib/locale/lang/en";
import locale from "element-ui/lib/locale";
import Pagination from "vue-pagination-2";
import VueCurrencyInput from "vue-currency-input";
import CKEditor from "ckeditor4-vue";
import VuePhoneNumberInput from "vue-phone-number-input";
import VueTelInput from "vue-tel-input";
import Datepicker from "vuejs-datepicker";
import OtpInput from "@bachdgvn/vue-otp-input";

locale.use(lang);

Vue.config.productionTip = false;

import "sweetalert2/dist/sweetalert2.min.css";
import "material-design-icons-iconfont/dist/material-design-icons.css";
// import './static/icon/iconfont'
import "vue-select/dist/vue-select.css";
import "vue-datetime/dist/vue-datetime.css";
import "vue-multiselect/dist/vue-multiselect.min.css";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import "vue-tel-input/dist/vue-tel-input.css";
// import 'vuetify/dist/vuetify.min.css';

import $ from "jquery";
window.jQuery = $;

import "./custom-declarations";

const pluginOptions = {
  globalOptions: { currency: "NGN" }
};

const swlOptions: any = {
  confirmButtonColor: "#0B105D",
  cancelButtonColor: "#ff7674"
};

// VUE USE
// Vue.use(Notifications);
Vue.use(VueChatScroll);
Vue.use(Notifications);
Vue.use(VeeValidate);
Vue.use(ElementUI);
Vue.use(VueSweetalert2, swlOptions);
Vue.use(CKEditor);
Vue.use(VueTelInput);
Vue.use(VueCryptojs);

const options = {
  color: "#e10032",
  failedColor: "#874b4b",
  thickness: "5px",
  transition: {
    speed: "0.2s",
    opacity: "0.6s",
    termination: 300
  },
  autoRevert: true,
  location: "left",
  inverse: false
};

Vue.use(VueProgressBar, options);

Vue.component("error", error);
// Vue.component('pagination', pagination);
Vue.component("loading", VueElementLoading);
Vue.component("v-select", vSelect);

Vue.component("datetime", Datetime);
Vue.component("multiselect", Multiselect);
// Vue.component('star-rating', StarRating);
// Vue.component('footer-bar', footerbar);
Vue.component("money-format", MoneyFormat);
Vue.component("custom-table", DataTable);
Vue.component("custom-modal", CustomModal);
Vue.component("pagination", Pagination);
Vue.component("sh-button", CustomButton);
Vue.use(VueCurrencyInput, { globalOptions: { currency: "NGN" } });
Vue.component("vue-phone-number-input", VuePhoneNumberInput);
Vue.component("datepicker", Datepicker);
Vue.component("v-otp-input", OtpInput);
// Vue.component("vue-tel-input", VueTelInput);

// Vue.component('table-tools', TableTools);

// Vue.component('pfizer-table', PfizerTable);

Vue.mixin(GlobalMixins);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
